package com.esoris.esocomponent.ui.common

import com.esoris.esocomponent.ui.defaultvalue.EsoPadding
import com.esoris.esocomponent.ui.defaultvalue.EsoSpacing
import androidx.compose.foundation.*
import androidx.compose.foundation.layout.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

/**
 * Digunakan untuk layout form.
 *
 * @param submitButton composable untuk button submit, ditampilkan paling bawah
 * @param content composable untuk isi form
 */
@Composable
fun EsoForm(
    modifier: Modifier = Modifier,
    submitButton: (@Composable () -> Unit)? = null,
    scrollable: Boolean = true,
    content: @Composable ColumnScope.() -> Unit,

) {
    Column(
        modifier = modifier
            .fillMaxSize()
            .padding(EsoPadding.medium)
    ) {

        Column(
            verticalArrangement = Arrangement.spacedBy(EsoSpacing.medium),
            modifier = if (scrollable) Modifier
                .weight(1f)
                .verticalScroll(rememberScrollState())
            else
                Modifier.weight(1f)
        ) {
            content()
        }

        // Only show spacing + button if button exists
        submitButton?.let {
            Spacer(modifier = Modifier.height(EsoSpacing.medium))
            it()
        }
    }
}